function Step2FabLeagueFootageContent({
    templateState,
    setTemplateField,
}) {
    return (
        <div className="card">
            <h2>FAB League Footage Content</h2>

            <label className="field">
                <span>Title</span>
                <input
                    type="text"
                    value={templateState.title || ""}
                    onChange={(e) =>
                        setTemplateField("title", e.target.value)
                    }
                    placeholder="LEAGUE FOOTAGE"
                />
            </label>

            <label className="field">
                <span>YouTube Embed Links</span>
                <textarea
                    rows="8"
                    value={templateState.videos_text || ""}
                    onChange={(e) =>
                        setTemplateField("videos_text", e.target.value)
                    }
                    placeholder={`https://www.youtube.com/embed/swNunrYcFOU
https://www.youtube.com/embed/OCLmxKPwzhw
https://www.youtube.com/embed/YtE4nCzLNZ0`}
                />

                <div className="field-help">
                    One YouTube embed link per line.
                </div>
            </label>
        </div>
    );
}

export default Step2FabLeagueFootageContent;